import React, { useEffect, useState } from "react";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Style from "../StoreList/StoreList.module.css";
import { getRestaurantsList } from "../../Api/BarestServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import InfiniteScroll from "react-infinite-scroller";
import { errorToast } from "../../Toast/Toast";

const RestaurantList = () => {
  const [data, setData] = useState();
  const [item, setItem] = useState(100);
  const [hasMoreItems, setHasMoreItems] = useState(true);
 
  useEffect(() => {
    GetRestaurantsData();
  }, []);
  const GetRestaurantsData = async () => {
    getRestaurantsList((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          let sorted = [...res.suppliers].sort((a,b)=>{
            return a.working_hours.open==='1'?-1:1
          })
          setData(sorted)
        }
      }else{
        console.error(res)
      }
    })

  };
  let subset = data && data.slice(0, item);

  const loadMore = () => {
    if (item === data.length || item >= data.length) {
      setHasMoreItems(false);
    } else {
      setTimeout(() => {
        setItem(item + 4);
        subset = data.slice(0, item + 4);
      }, 2000);
    }
  };
  return (
    <ul className={Style.ListHolder}>
      {data && (
        <InfiniteScroll
          style={{ width: "90vw", height: "100vh" }}
          loadMore={loadMore}
          hasMore={hasMoreItems}
          loader={
            <PointSpreadLoading style={{ height: "3rem" }} color={"#ab0c59"} />
          }
        >
          {subset?.map((item) => {
            return (
              <Link
                key={item.id}
                to={{
                  pathname: `/supplier/${item.id}/`,
                  state: item,
                }}
              >
                <li className={Style.StoreInfo}>
                  <div className={Style.ImageHolder}>
                    <img
                      src={`//cdn.barest.ir/supplier/logo/${item.logo}.jpg`}
                      alt="رستوران"
                    />
                  </div>
                  <div className={Style.StoreInfoHolder}>
                    <h4 className={Style.StoreNameHolder}>{item.name}</h4>
                    <p className={Style.Condition}>
                      {" "}
                      وضعیت:{" "}
                      {item.working_hours.open === "1" ? (
                        <span className={Style.openCheck}>باز</span>
                      ) : (
                        <span>بسته</span>
                      )}
                    </p>
                    <div className={Style.StoreRate}>
                      <div className={Style.FixRate}>
                        <div className={Style.RateHolder}>
                          <div className={Style.grayStar}>
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                            <FontAwesomeIcon icon={faStar} />
                          </div>
                          <div
                            className={Style.GoldStar}
                            style={{ width: `${item.supplier_rate * 20}%` }}
                          >
                            <div className={Style.GoldStarHolder}>
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                              <FontAwesomeIcon icon={faStar} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </Link>
            );
          })}
        </InfiniteScroll>
      )}
    </ul>
  );
};

export default RestaurantList;
